import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID =
  import.meta.env.VITE_GA_MEASUREMENT_ID ||
  import.meta.env.VITE_GA_TRACKING_ID ||
  "G-D1JQVWYJM6";

export function GoogleAnalyticsPageview() {
  const location = useLocation();

  // === DETAILED REAL INTEGRATION for GA ===
  // One-time runtime validation / monitoring of the gtag integration
  // (the script in index.html uses {{GA_MEASUREMENT_ID}} replaced at build with the value from BRAND/ VITE env)
  // Logs and optionally sends event to confirm the real loaded gtag (with send_page_view:false for SPA control)
  useEffect(() => {
    if (typeof window === "undefined") return;

    const loaded = typeof (window as any).gtag === "function";
    const expected = GA_MEASUREMENT_ID;

    // Log for devs / monitoring (visible in console + can be captured by other tools)
    console.info("[GA Monitor] gtag loaded:", loaded, "measurement_id:", expected);

    if (loaded) {
      // Optional diagnostic (non pageview) to help validate in analytics tools
      try {
        (window as any).gtag("event", "ga_script_validated", {
          measurement_id: expected,
          validated_at: new Date().toISOString(),
        });
      } catch {}
    } else {
      console.warn("[GA Monitor] gtag no está disponible — verificar script en index.html");
    }
  }, []);

  useEffect(() => {
    if (typeof window.gtag !== "function") return;

    // With send_page_view: false in the gtag config snippet,
    // we control all pageviews from the SPA router for accuracy.
    const page_path = `${location.pathname}${location.search}${location.hash}`;

    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
